// @flow
/**
 * Used for shared apexchart configuration to help keep charts consistent
 */
export const TEAL = '#91efda'
export const DARK_TEAL = '#3cdbb8'
export const BLUE = '#4296cb'
export const LIGHT_BLUE = '#7ddaff'
export const RED = '#ff505f'
export const ORANGE = '#ffa23b'
export const PURPLE = '#9c6bff'
export const DARK_PURPLE = '#6313FF'
export const DARK_WHITE = '#f0f4f6'

// darker colors
// export const DARK_BLUE = '#206794'
// export const DARK_TEAL = '#077C62'
// export const DARK_ORANGE = '#9F6000'
// export const DARK_RED = '#A51E1E'
// export const DARK_MAGENTA = '#9F1B79'

export const chartOptions = {
  fontFamily: '"Maison Neue", "Helvetica Neue", Helvetica, Arial, "Lucida Grande", sans-serif',
  toolbar: {
    show: false,
  },
}

export const tooltipOptions = {
  enabled: true,
  theme: 'dark',
}
